/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierCalendarRestService } from '@gh/supplier-shared-data';
import { Observable } from 'rxjs';
import { CalendarModel } from '../models';

@Injectable()
export class SupplierCalendarBusinessService {
  constructor(
    private userContext: SupplierUserContext,
    private restService: SupplierCalendarRestService,
  ) {
  }

  getCalendarItems(year: number, month: number, officeId?: ID): Observable<CalendarModel[]> {
    return this.restService.getAll({ officeId, year, month });
  }
}
